import { Outlet } from "react-router-dom"
import { CreditHeader } from "../pages/Credit/components/CreditHeader"
import { SelfHiringProvider } from "@/app/contexts/SelfHiringContext"
import { CreditFooter } from "../pages/Credit/components/CreditFooter"

function SelfHiringLayout() {
  return (
    <div className="min-h-screen w-full bg-[#ebf0f5] dark:bg-gray-950">
      <SelfHiringProvider>
        <CreditHeader />

        <main className="flex flex-col items-center pb-40 md:pb-20 h-full justify-center w-full">
          <div className="mx-auto w-full max-w-[1440px] px-4">
            <Outlet />
          </div>
        </main>

        <div className="fixed inset-x-0 bottom-0 z-50 bg-[#ebf0f5] dark:bg-gray-950">
          <CreditFooter />
        </div>
      </SelfHiringProvider>
    </div>
  )
}

export default SelfHiringLayout